export default __webpack_public_path__ + "static/media/p_b_logo.93d7a711.png";